<template>
	<vs-button
		v-bind="$attrs"
		v-on="$listeners"
		class="font-bold"
		type="border"
		icon-pack="nucleo"
		icon="nucleo-file-download-94-2"
	>{{ btnText }}</vs-button>
</template>

<script>
export default {
	name: "CbsDownloadButton",
	inheritAttrs: false,
	props: {
		btnText: {
			type: String,
			default: "Download"
		}
	}
};
</script>
